define('uikit/collections/table.row',['require','exports','module','underscore','backbone','marionette','../channel','../helper/browser','../extra/key.codes','../elements/dropdown','./table.row','../mixins/component.mixin','./table.cell','../views/proxy.options.view','../templates','../extra/extend.util'],function(require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var channel = require('../channel');
  var browser = require('../helper/browser');
  var CODES = require('../extra/key.codes');
  var Dropdown = require('../elements/dropdown');
  var TableRowView = require('./table.row');
  var ComponentMixin = require('../mixins/component.mixin');
  var TableCellView = require('./table.cell');
  var ProxyOptionsView = require('../views/proxy.options.view');
  var Templates = require('../templates');
  var ExtendUtil = require('../extra/extend.util');

  var DATA_FIELD = 'data';
  var SORT_FIELD = 'sort';
  var FORMATTER_FIELD = 'formatter';

  var MANUAL_SELECTION = 'manual';

  var TableRowView = Mn.CollectionView.extend(ComponentMixin).extend({
    tagName: 'tr',

    modelEvents: {
      'table:row:selection:changed': 'checkActiveClass',
    },

    childView: TableCellView,

    options: {
      link: null,
      linkTarget: '_self',
      active: false,
      focused: false,
      negative: false,
      positive: false,
      warning: false,
      muted: false,
      disabled: false,
      emphasized: false,
      selectable: true,
      color: '',
      isSpannedRow: false,
      isFirstSpannedRow: false
    },

    forceUpdate: { selectable: true },

    events: {
      click: function(ev) {
        if (!this.selectable) {
          return;
        }
        if (!ev.originalEvent._clickedATag) {
          this.triggerMethod('press');
        }
      },
      dblclick: function(ev) {
        if (!this.selectable) {
          return;
        }
        if (!ev.originalEvent._clickedATag) {
          this.triggerMethod('double:press');
        }
      },
      'click a': function(ev) {
        if (!this.selectable) {
          return;
        }
        ev.originalEvent._clickedATag = true;
      },
      keydown: function(ev) {
        if (this.el == ev.originalEvent.target) {
          if (ev.keyCode == CODES.ENTER_KEY) {
            this.triggerMethod('press');
            // trigger enter event in case
            // any one cares to listen on that
            this.triggerMethod('enter');
          }
        }
      },
    },

    triggers: {
      mouseenter: {
        preventDefault: false,
        stopPropagation: false,
        event: 'mouseenter',
      },
      mouseleave: {
        preventDefault: false,
        stopPropagation: false,
        event: 'mouseleave',
      },
      focus: {
        preventDefault: false,
        stopPropagation: false,
        event: 'focus',
      },
      blur: {
        preventDefault: false,
        stopPropagation: false,
        event: 'blur',
      },
    },

    initialize: function() {
      this.tableView = this.getOption('tableView');
      ComponentMixin.initialize.apply(this, arguments);

      if (!this.link && this.tableView && this.tableView.rowLinkFormatter) {
        this.link = this.tableView.rowLinkFormatter(this.model);
      }

      if (!this.linkTarget && this.tableView && this.tableView.rowLinkTarget) {
        this.linkTarget = this.tableView.rowLinkTarget;
      }

      this.collection = this.getColumnCollection();

      this.on('before:add:child', function(view) {
        var columnModel = view.getOption('columnModel');
        if (_.isFunction(columnModel.get('onBeforeAdd'))) {
          columnModel.get('onBeforeAdd').call(this, view, this.model, columnModel);
        }
      })
        .on('add:child', function(view) {
          var columnModel = view.getOption('columnModel');
          if (_.isFunction(columnModel.get('onAdd'))) {
            columnModel.get('onAdd').call(this, view, this.model, columnModel);
          }
          this.updateColumnViewArray();
        })
        .on('remove:child', function() {
          this.updateColumnViewArray();
        })
        .listenTo(this.collection, 'change:visible', function() {
          this._renderChildren();
        })
        .on(
          'change:link change:linkTarget',
          function() {
            this.children.each(function(child) {
              child.link = this.link;
              child.linkTarget = this.linkTarget;
            }, this);
          },
          this
        )
        .on(
          'change:active',
          function() {
            if (this.tableView.invertColumnChildViewsOnActive) {
              this.updateColumnViewsInvertedValues();
            }
          },
          this
        )
        .on(
          'change:focused',
          function() {
            if (this.tableView.invertColumnChildViewsOnFocus) {
              this.updateColumnViewsInvertedValues();
            }
          },
          this
        )
        .on(
          'focus',
          function() {
            this.focused = true;
          },
          this
        )
        .on(
          'blur',
          function() {
            this.focused = false;
          },
          this
        );
      this.updateColumnViewArray();
      this.checkActiveClass();
    },

    getColumnCollection: function() {
      return this.tableView.columns;
    },

    // keeping empty function for legacy support
    childViewOptions: function(columnModel, columnIndex) {
      return {};
    },

    // rowSpanOptions have two properties, a startIndex of the first row to span, and the numberOfRows to span, ie { startIndex: 1, numberOfRows: 5 }
    // rowSpanOptions can be passed as a straight JSON object, or as a function that will take the tableView's collection and
    // return a JSON object
    _evaluateRowSpanOptions: function(rowSpanOptions) {
      if (_.isFunction(rowSpanOptions)) {
        rowSpanOptions = rowSpanOptions(this.tableView.collection);
      }

      return rowSpanOptions;
    },

    // if rowSpanOptions have been set, returns the number of rows to be spanned if the current row is the first row
    // to be spanned.  This value is applied the the table cell childView to set the "rowSpan" attribute in the HTML.
    _getRowSpan: function(rowSpanOptions) {
      rowSpanOptions = this._evaluateRowSpanOptions(rowSpanOptions);

      return rowSpanOptions && rowSpanOptions.startIndex === this._index ? rowSpanOptions.numberOfRows : null;
    },

    // returns true if a row falls inside the range of spanned rows, otherwise returns false
    _isSpannedRow: function(rowSpanOptions) {
      rowSpanOptions = this._evaluateRowSpanOptions(rowSpanOptions);

      return rowSpanOptions
             && (this._index >= rowSpanOptions.startIndex)
             && (this._index < (rowSpanOptions.startIndex + rowSpanOptions.numberOfRows));
    },

    // returns true if a table cell within a row is one that is being spanned (and therefore is a duplicate table cell), otherwise returns false
    _isSpannedTableCell: function(rowSpanOptions) {
      rowSpanOptions = this._evaluateRowSpanOptions(rowSpanOptions);

      return rowSpanOptions
             && (this._index > rowSpanOptions.startIndex)
             && (this._index < (rowSpanOptions.startIndex + rowSpanOptions.numberOfRows));
    },


    // Override the navite Mn.addChild() method so we can exclude spanned table cells from being added as childViews
    addChild: function(child, ChildView, index) {
      var rowSpanOptions = child.get('rowSpanOptions');
      var isFirstSpannedRow = this._evaluateRowSpanOptions(rowSpanOptions) && this._evaluateRowSpanOptions(rowSpanOptions).startIndex === this._index;

      // if we are currently in a row that will have a table cell that is rowspanned, we are going to set an CSS class
      // on the row to allow it to be styled
      if (this._isSpannedRow(rowSpanOptions)) {
        this.options.isFirstSpannedRow = isFirstSpannedRow;
        this.options.isSpannedRow = true;
      }

      // if we are a table cell that is going to be spanned by another table cell, we DO NOT want to add that childView
      // to the row
      if (this._isSpannedTableCell(rowSpanOptions)) {
        return;
      }

      return Mn.CollectionView.prototype.addChild.call(this, child, ChildView, index);
    },

    buildChildView: function(child, ChildViewClass, childViewOptions) {
      var rowSpan = this._getRowSpan(child.get('rowSpanOptions'));

      childViewOptions = _.extend(
        {},
        {
          model: this.model,
          rowView: this,
          columnModel: child,
          columnCollection: this.getColumnCollection(),
          columnIndex: this.collection.indexOf(child),
          selectable: this.selectable,
          link: this.link,
          linkTarget: this.linkTarget,
          text: '',
          hasChildView: TableCellView.hasChildView(child, this.model),
          collapsing: this.isColumnCollapsing(child),
          rowSpan:  rowSpan,
        },
        childViewOptions,
        child.attributes
      );
      ChildViewClass = ExtendUtil.extendClassBehaviors(ChildViewClass, childViewOptions);
      return Mn.CollectionView.prototype.buildChildView.call(this, child, ChildViewClass, childViewOptions);
    },

    isColumnCollapsing: function(columnModel) {
      // we only to add the collapsing class to the td when there is no header
      // otherwise we let the th handling the collapsing
      return this.tableView.getOption('headless') && columnModel.get('collapsing');
    },

    filter: function(columnModel, index, collection) {
      return columnModel.get('visible') !== false;
    },

    updateColumnViewsInvertedValues: function() {
      var invertedValue = this.active || this.focused;
      _.each(
        this.columnViews,
        function(view) {
          if (!view) {
            return;
          }
          view.inverted = invertedValue;
        },
        this
      );
    },

    updateColumnViewArray: function() {
      var columnViews = [];
      this.columnViews = this.children.each(function(cellView) {
        if (cellView.columnChildView) {
          columnViews.push(cellView.columnChildView);
        }
      });
      this.columnViews = columnViews;
    },

    updateAttributes: function() {
      if (this.tableView.getOption('focusable') && this.tableView.getOption('selectable')) {
        this.$el.prop('tabindex', 0);
      } else {
        this.$el.removeAttr('tabindex');
      }
      this.addClass('active', this.getBoolOption('active'))
        .addClass('negative', this.getBoolOption('negative'))
        .addClass('positive', this.getBoolOption('positive'))
        .addClass('warning', this.getBoolOption('warning'))
        .addClass('muted', this.getBoolOption('muted'))
        .addClass('emphasized', this.getBoolOption('emphasized'))
        .addClass('disabled', this.getBoolOption('disabled'))
        .addClass(this.getOption('color'), this.getBoolOption('color'))
        .addClass('row-spanned-first', this.getBoolOption('isFirstSpannedRow'))
        .addClass('row-spanned', this.getBoolOption('isSpannedRow'));

      if (this.tableView.invertColumnChildViewsOnActive) {
        this.updateColumnViewsInvertedValues();
      }
    },

    checkActiveClass: function() {
      if (this.tableView.selection === MANUAL_SELECTION) {
        // do nothing
      } else if (!this.selectable) {
        this.active = false;
      } else {
        this.active = this.tableView.isSelected(this.model);
      }
    },
  });

  module.exports = TableRowView;
});

